import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function branch(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@branch/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@branch/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@branch/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@branch/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@branch/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@branch/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}